import {
  getReceiptSystemAccountIdSafe,
  native,
  type UserInfo,
} from '@forest/native-services'
import { AbortError, ensureAuthenticatedUser } from '@forest/paywall-core'
import { showDialog } from '~/components/dialog'
import { appVersion } from '~/lib/params'
import { m } from '~/paraglide/messages'
import { $receiptSystemAccountId, $userInfo } from '~/store'

export { AbortError }

export async function getAuthenticatedUserInfo(): Promise<UserInfo> {
  const userInfo = await ensureAuthenticatedUser({
    getUserInfo: async () => {
      const result = await native.user.getUserInfo()
      if (!result.success) throw new Error('getUserInfo failed')
      if (!result.data) throw new Error('getUserInfo returned null data')
      return { success: true as const, data: result.data }
    },
    auth: () => native.auth.auth(),
    bindLegacyUser: () => native.auth.bindLegacyUser(),
    onBeforeGuestUpgrade: () =>
      new Promise<void>((resolve, reject) => {
        showDialog({
          title: m.dialog_log_in_title(),
          description: m.dialog_log_in_content(),
          buttonText: m.OK(),
          buttonAction: resolve,
          closeButton: { action: () => reject(new AbortError()) },
        })
      }),
    onAfterGuestUpgrade: async () => {
      $receiptSystemAccountId.set(
        await getReceiptSystemAccountIdSafe(appVersion),
      )
    },
    onBeforeLegacyBind: () =>
      new Promise<void>((resolve, reject) => {
        showDialog({
          title: m.dialog_log_in_legacy_title(),
          description: m.dialog_log_in_legacy_content(),
          buttonText: m.OK(),
          buttonAction: resolve,
          closeButton: { action: () => reject(new AbortError()) },
        })
      }),
    onLegacyBindStart: () => {
      window.dispatchEvent(new CustomEvent('hide-close-button'))
    },
    onLegacyBindEnd: () => {
      window.dispatchEvent(new CustomEvent('show-close-button'))
    },
    onUserInfo: (nextUserInfo) => {
      $userInfo.set(nextUserInfo)
    },
  })

  return userInfo
}
